<button pButton
	type="button"
	class="home"
	[dt]="homeButtonDt"
	(click)="returnToHome()"><span class="home-icon"></span></button>

<div class="breadcrumb-container">
	@for (breadcrumb of breadcrumbs(); track breadcrumb; let last = $last) {
		<div class="breadcrumb-item"
			>
			@if (!last) {
				<a bas-link
					(click)="navigateRouted(breadcrumb,$event)"
				>{{breadcrumb.description}}</a>
			} @else {
				<span>{{breadcrumb.description}}</span>
			}
		</div>
	}
</div>